import { baseUrl } from "../../../config.js";
import { getUrlExtension } from "../../../functions/HelperFuncs.js";

export default {
  data() {
    return {
      loginScreenIsOpen: false,
      socialOptions: [
        {
          name: "facebook",
        },
        {
          name: "instagram",
        },
        {
          name: "twitter",
        },
        {
          name: "linkedin",
          url: "https://www.linkedin.com/",
        },
        {
          name: "pinterest",
        },
        {
          name: "youtube",
          urlRule: [
            {
              includes: "@",
              url: "https://www.youtube.com/channel/",
            },
            {
              includes: "",
              url: "https://www.youtube.com/channel/",
            },
          ],
        },
        {
          name: "vimeo",
        },
        {
          name: "tiktok",
          url: "https://www.tiktok.com/@",
        },
      ],
      socialLinks: [],
      brandingOptions: ["home_logo", "name", "home_screen"],
      brandingImages: {},
    };
  },
  created() {
    this.getContent();
  },
  computed: {
    hasBrandVideo() {
      if (this.brandingImages.home_screen) {
        if (getUrlExtension(this.brandingImages.home_screen) === "mp4") {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    getContent() {
      this.$axios.get(`${baseUrl}/company`).then((r) => {
        //get socials
        this.socialOptions.forEach((social) => {
          const link = r.data[social.name];

          if (link) {
            this.socialLinks.push({ ...social, value: link });
          }
        });

        const brandingItemsTMP = {};
        //get branding items
        this.brandingOptions.forEach((option) => {
          const item = r.data[option];
          if (item) {
            brandingItemsTMP[option] = item;
          }
        });

        this.brandingImages = brandingItemsTMP;
      });
    },
    createSocialLink(social) {
      if (social.url) {
        return `${social.url}${social.value}`;
      } else if (social.urlRule) {
        //has special rule
        return `${this.getCorrectUrl(social)}${social.value}`;
      } else {
        return `https://${social.name}.com/${social.value}`;
      }
    },

    getCorrectUrl(social) {
      let result = "";

      social.urlRule.forEach((rule) => {
        if (social.value.includes(rule.includes)) {
          result = rule.url;
        }
      });

      return result;
    },

    imageLoaded(e) {
      e.currentTarget.classList.add("loaded");
    },

    openLoginScreen(variable) {
      setTimeout(
        () => {
          this.loginScreenIsOpen = variable;
        },
        !variable ? 400 : 0
      );
    },
  },
};
